import numeral from "numeral";

export function setupNumeralFilters(instance) {
  instance.filter("currency", (value) => {
    if (isNaN(value) || !isFinite(value)) return "";
    return numeral(value).format("0,0.00");
  });
}
